module.exports = __webpack_public_path__ + "static/media/slippers_desktop.e9cc234d.jpg";